const calendarData = []
const isLoading = false
const bookingDetails = []
const billItemDetails = []
const bookingPaidStatusArray = ["APPROVED", "COMPLETE", "PAGO", "PAID", "WALLET", "COMPLETED"]

export default {
  calendarData,
  isLoading,
  bookingDetails,
  billItemDetails,
  bookingPaidStatusArray
}
